export default "__VITE_ASSET__CTN02MoS__"